import Modal from 'react-modal';
import React, { useState } from 'react';
import moment from 'moment/moment';
import LoadingSpinner from '../../common/LoadingSpinner';
import { executeHttpRequest } from '../../../epics/api';
import { getErrorMessages } from '../../../utils';
import { TConsultantSplit } from '../shifts/AgentShiftForm';
import { TAgent, TPageNotification } from '../../../types';


type TModalConfirmEditSeriesProps = {
    notification: TPageNotification;
    reloadData: () => void;
    isOpen: boolean;
    handleClose: () => void;
    handleCloseParentModal: () => void;
    fields: TConsultantSplit[];
    selectedDate: Date;
    consultants: TAgent[];
    seriesId: number;
    setError: (error: string) => void;
}

export function ModalConfirmEditSeriesConsultants({
    notification,
    reloadData,
    isOpen,
    handleClose,
    handleCloseParentModal,
    fields,
    selectedDate,
    consultants,
    seriesId,
    setError,
}: TModalConfirmEditSeriesProps) {

    const [isLoading, setIsLoading] = useState(false);
    const consultantSplits = Object.values(fields)
        .filter(field => !!field.agent && !!field.split_value);

    const handleConfirm = (): void => {
        setIsLoading(true);

        const payloadData = {
            jobs_only: true,
            from_date: moment(selectedDate).format('YYYY-MM-DD'),
            consultant_splits: consultantSplits,
        };

        executeHttpRequest(
            `series/${seriesId}/update_series/`,
            'patch',
            payloadData,
        ).then(() => {
            setIsLoading(false);
            handleClose();
            handleCloseParentModal();
            notification.success(
                'Success',
                `${seriesId} successfully edited`
            );
            reloadData();
        }).catch(err => {
            setIsLoading(false);
            setError(getErrorMessages(err));
            handleClose();
        });
    };


    return (
        <Modal
            className="add-qualifying-questions-modal"
            isOpen={isOpen}
            onRequestClose={handleClose}
            contentLabel="Confirm questions"
            ariaHideApp={false}
        >
            <p className="modal-title">Update Consultants</p>
            <div className="qualifying-questions-form">
                <div>
                    <p>Are you sure you want to update consultants on the ongoing job <b>{seriesId}</b>?</p>
                    <p>From date: <b>{moment(selectedDate).format('DD/MM/YYYY')}</b></p>
                    <table>
                        <thead>
                        <tr>
                            <th style={{ textAlign: 'left' }}>Consultant</th>
                            <th>Split Value</th>
                        </tr>
                        </thead>
                        <tbody>
                        {consultantSplits.map(consultantSplit => (
                            <tr key={consultantSplit.agent}>
                                <td className="qualifying-questions-field" style={{ textAlign: 'left' }}>
                                    {consultants.find(agent => agent.id === consultantSplit.agent)?.full_name}
                                </td>
                                <td>
                                    <b>{consultantSplit.split_value}</b>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <button
                className="continue btn--round-big"
                onClick={handleConfirm}
                type="button"
                disabled={isLoading}
            >
                {isLoading ? (
                    <LoadingSpinner
                        className="edit-series-spinner"
                        backgroundColor="white"
                    />
                ) : (
                    'CONFIRM'
                )}
            </button>
            {!isLoading && (
                <button className="back" onClick={handleClose} type="button">
                    CANCEL
                </button>
            )}
        </Modal>
    );
}
